import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../Contexts/AuthContext';
import { CustomNavLink, LoggedInDropdown } from './components';
import MobileHeader from './MobileHeader';
import { getNavigationList, NAVIGATION_LIST } from './helpers';
import { OfferBar } from '../Components/OfferBar';

// The Header component logic is now renamed to Navbar
const Navbar = () => {

  // Destructuring values from AuthContext
  const { user = {}, membership = {} } = useContext(AuthContext);

  const [navigationList, setNavigationList] = useState(NAVIGATION_LIST);

  useEffect(() => {
    const newNav = getNavigationList({ user, membership });

    setNavigationList(prev => {
      try {
        if (JSON.stringify(prev) === JSON.stringify(newNav)) {
          return prev; // no change → avoid setState
        }
      } catch (e) {}
      return newNav;
    });
  }, [user?.role, membership?.status]);

  return (
    // Wrapper fixed for both OfferBar + Navbar
    <div className="fixed top-0 left-0 w-full z-50">
      
      {/* Offer Bar */}
      <OfferBar />

      {/* Navbar */}
      <header className="w-full bg-[#171A26] bg-gradient-radial py-4">
        <nav className="container mx-auto px-4 lg:px-15 flex justify-between items-center">
          
          <Link to='/' className="flex items-center gap-6">
            <img className="w-auto h-12" src="/assets/FWPI-logo.png" alt="FWPI Logo" />
          </Link>

          {/* Desktop Navigation (Hidden on Mobile) */}
          <div className="hidden lg:flex items-center gap-6">
            <div className="flex items-center gap-6">
              {navigationList.map((navDetails, index) => (
                <CustomNavLink
                  key={index}
                  {...navDetails}
                />
              ))}
            </div>

            {/* Logged in dropdown */}
            <div className="flex items-center gap-3">
              <LoggedInDropdown />
            </div>
          </div>

          <MobileHeader />
        </nav>
      </header>
    </div>
  );
};

export default Navbar;
